import { twMerge } from "tailwind-merge"

import { Bee } from "./BeeKit"

export type MessageQuote = {
  message: string
  author: string
}

export type ThankYouNoteMessageCarouselProps = {
  messageQuotes: MessageQuote[]
}

export function ThankYouNoteMessageCarousel(props: ThankYouNoteMessageCarouselProps) {
  const { messageQuotes } = props

  return (
    <Bee.Carousel className="h-full min-h-[134px] w-full">
      {messageQuotes.map((messageQuote, i) => (
        <QuoteBlock key={i} messageQuote={messageQuote} />
      ))}
    </Bee.Carousel>
  )
}

function QuoteBlock(props: { messageQuote: MessageQuote }) {
  const { messageQuote } = props
  const { message, author } = messageQuote

  const names = author.split(/\s+/)
  const firstInitial = names.length > 0 ? names[0].charAt(0) : ""
  const lastInitial = names.length > 1 ? names.at(-1)!.charAt(0) : ""
  const initials = (firstInitial + lastInitial).toUpperCase()
  const paddingClass = initials.length == 2 ? "p-1" : "py-1 px-2"

  return (
    <div className="flex grow-0 flex-col gap-4 text-gray-900">
      <div className="w-full rounded-xl bg-gray-100 px-4 py-2">
        <div className="line-clamp-3 w-full text-sm">{`“${message}”`}</div>
      </div>
      <div className="flex gap-2 text-xs">
        {initials.length > 0 ? (
          <span>
            <span className={twMerge("bg-magenta-100 text-magenta-500 rounded-full", paddingClass)}>{initials}</span>
          </span>
        ) : null}
        <span>{author}</span>
      </div>
    </div>
  )
}
